module.exports = __webpack_public_path__ + "static/media/kongsberg-logo.a0227417.png";